import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSlotProps } from '@react-spectrum/utils';
import { dhExclamation, vsLink } from '@deephaven/icons';
import "./SocketedButton.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SocketedButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  var children = props.children,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    id = props.id,
    _props$isLinked = props.isLinked,
    isLinked = _props$isLinked === void 0 ? false : _props$isLinked,
    _props$isLinkedSource = props.isLinkedSource,
    isLinkedSource = _props$isLinkedSource === void 0 ? false : _props$isLinkedSource,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    onClick = props.onClick,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    style = props.style,
    dataTestId = props['data-testid'];

  // Spectrum container components such as `ButtonGroup` provide
  // UNSAFE_className prop for the `button` slot via a SlotProvider (
  // https://github.com/adobe/react-spectrum/blob/%40adobe/react-spectrum%403.33.1/packages/%40react-spectrum/buttongroup/src/ButtonGroup.tsx#L104-L107)
  // This can be retrieved via `useSlotProps` to allow our buttons to be styled
  // correctly inside the container.
  var _useSlotProps = useSlotProps({}, 'button'),
    UNSAFE_className = _useSlotProps.UNSAFE_className;
  return /*#__PURE__*/_jsxs("button", {
    ref: ref,
    type: "button",
    className: classNames('btn-socketed', {
      'btn-socketed-linked': isLinked !== undefined && isLinked || isLinkedSource
    }, {
      'btn-socketed-linked-source': isLinkedSource
    }, {
      'is-invalid': isInvalid
    }, className, UNSAFE_className),
    id: id,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    style: style,
    disabled: disabled,
    "data-testid": dataTestId,
    children: [children, /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: vsLink,
      className: "linked btn-socketed-icon",
      transform: "down-1"
    }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: dhExclamation,
      className: "is-invalid btn-socketed-icon"
    })]
  });
});
SocketedButton.displayName = 'SocketedButton';
export default SocketedButton;
//# sourceMappingURL=SocketedButton.js.map